(function () {
  if (window.__ziglyServiceBookingInit) return;
  window.__ziglyServiceBookingInit = true;

  const BUTTON_SELECTOR = '.available-service-card__book-button';
  const DRAWER_SELECTOR = '.available-service-drawer';
  const LOGIN_BUTTON_SELECTOR = '[data-booking-login]';
  const DEFAULT_LOGIN_URL = '/account/login';
  // The service carousel is lazy-loaded, so its cards can arrive well after DOMContentLoaded.
  const REOPEN_WAIT_MS = 60000;
  const isLoggedIn = !!window.ZIGLY_IS_LOGGED_IN;

  const STORAGE = {
    action: 'zigly_after_login_action',
    url: 'zigly_after_login_url',
    variant: 'zigly_after_login_variant_id'
  };

  function getCurrentUrl() {
    return window.location.pathname + window.location.search + window.location.hash;
  }

  function buildLoginUrl(btn) {
    const baseUrl =
      btn.getAttribute('data-login-base-url') ||
      btn.getAttribute('href') ||
      DEFAULT_LOGIN_URL;

    const separator = baseUrl.indexOf('?') > -1 ? '&' : '?';
    return baseUrl + separator + 'return_to=' + encodeURIComponent(getCurrentUrl());
  }

  function setBookingState(variantId) {
    sessionStorage.setItem(STORAGE.action, 'book_service');
    sessionStorage.setItem(STORAGE.url, getCurrentUrl());
    sessionStorage.setItem(STORAGE.variant, String(variantId || ''));
  }

  function clearBookingState() {
    sessionStorage.removeItem(STORAGE.action);
    sessionStorage.removeItem(STORAGE.url);
    sessionStorage.removeItem(STORAGE.variant);
  }

  /** The Book Now button of the package the customer was booking, else the first one. */
  function findBookButton(variantId) {
    if (variantId) {
      const card = document.querySelector('.available-service-card[data-variant-id="' + variantId + '"]');
      const button = card && card.querySelector(BUTTON_SELECTOR);
      if (button) return button;
    }
    return document.querySelector(BUTTON_SELECTOR);
  }

  function reopenDrawerAfterLogin() {
    const action = sessionStorage.getItem(STORAGE.action);
    const savedUrl = sessionStorage.getItem(STORAGE.url);
    const variantId = sessionStorage.getItem(STORAGE.variant) || '';
    const currentUrl = getCurrentUrl();

    if (!isLoggedIn || action !== 'book_service' || !savedUrl) return;

    if (currentUrl !== savedUrl) {
      window.location.replace(savedUrl);
      return;
    }

    clearBookingState();

    // Wait for the package card to exist; the drawer restores the rest from the saved booking.
    const startedAt = Date.now();
    (function tryOpen() {
      const card = variantId && document.querySelector('.available-service-card[data-variant-id="' + variantId + '"]');
      if (card || Date.now() - startedAt > REOPEN_WAIT_MS) {
        const button = findBookButton(variantId);
        if (button) button.click();
        return;
      }
      setTimeout(tryOpen, 250);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reopenDrawerAfterLogin, { once: true });
  } else {
    reopenDrawerAfterLogin();
  }

  document.addEventListener('click', function (e) {
    const loginBtn = e.target.closest(LOGIN_BUTTON_SELECTOR);
    if (!loginBtn || isLoggedIn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const drawer = loginBtn.closest(DRAWER_SELECTOR);
    setBookingState(drawer ? drawer.dataset.variantId : '');
    window.location.assign(buildLoginUrl(loginBtn));
  }, true);
})();
